import {
  ChiaveMisura,
  DashboardBookingListDto,
  DashboardObiettiviPlDto,
  DashboardProjectDto,
  DashboardProjectFilterDto,
  DashboardProjectFilterInputDto,
  DashboardProjectTotalsDto,
  DashboardUserListDto,
  FilterDtoStatoEnum,
  RptSalPlannedFilterDto,
  RptSalPlannedSearchResponseDto,
  UserListFilterDto,
} from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import {
  getChiaviMisura,
  getDashboardProjectFilters,
  getDashboardProjects,
  getDashboardProjectsCurrentYear,
  getDashboardUsers,
  getOverbookingUsers,
  getPlGoals,
  getSALPlanning,
  getUnderbookingUsers,
  saveDashboardPeopleFilters,
  saveDashboardProjectFilters,
  saveDashboardSalFilters,
  saveDashboardStoricoFilters,
  StoricoFiltersDto,
} from './actions';
import { FilterPeriodEnum } from 'enums/dashboard.enum';

interface InitialState {
  dashboardProjects: DashboardProjectDto[] | undefined | null;
  dashboardProjectTotals: DashboardProjectTotalsDto | undefined | null;
  dashboardProjectsCurrentYear: DashboardProjectDto[] | undefined | null;
  dashboardProjectTotalsCurrentYear: DashboardProjectTotalsDto | undefined | null;
  dashboardUsers: DashboardUserListDto | undefined | null;
  dashboardUnderbookingUsers: DashboardBookingListDto | undefined | null;
  dashboardOverbookingUsers: DashboardBookingListDto | undefined | null;
  filtersDashboardProject: DashboardProjectFilterDto | undefined | null;
  filtersDashboardProjectUsed: DashboardProjectFilterInputDto | undefined | null;
  filtersDashboardPeopleUsed: UserListFilterDto | undefined | null;
  plGoals: DashboardObiettiviPlDto | undefined;
  salPlanning: RptSalPlannedSearchResponseDto | undefined;
  filtersDashboardSalUsed: RptSalPlannedFilterDto | undefined;
  filtersDashboardStoricoUsed: StoricoFiltersDto | undefined;
  chiaviMisura: ChiaveMisura[] | undefined;
}

const initialState: InitialState = {
  dashboardProjects: [],
  dashboardProjectTotals: null,
  dashboardProjectsCurrentYear: [],
  dashboardProjectTotalsCurrentYear: null,
  dashboardUsers: null,
  dashboardUnderbookingUsers: null,
  dashboardOverbookingUsers: null,
  filtersDashboardProject: null,
  filtersDashboardProjectUsed: {
    projectStatus: [
      FilterDtoStatoEnum.WorkInProgress,
      FilterDtoStatoEnum.ControlloCdg,
      FilterDtoStatoEnum.ControlloCl,
      FilterDtoStatoEnum.EconomicsClosed,
      FilterDtoStatoEnum.ReportingClosed,
      FilterDtoStatoEnum.Completed,
    ],
    // year: new Date().getFullYear(),
    filtroAnnualita: FilterPeriodEnum.CURRENT_YEAR,
  },
  filtersDashboardPeopleUsed: null,
  plGoals: undefined,
  salPlanning: undefined,
  filtersDashboardSalUsed: undefined,
  filtersDashboardStoricoUsed: undefined,
  chiaviMisura: undefined,
};

export const dashboardReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getDashboardProjects.fulfilled, (state, action) => {
      state.dashboardProjects = action.payload?.projects;
      if (action.payload?.totals) {
        state.dashboardProjectTotals = action.payload.totals;
      }
    })
    .addCase(getDashboardProjectsCurrentYear.fulfilled, (state, action) => {
      state.dashboardProjectsCurrentYear = action.payload?.projects;
      state.dashboardProjectTotalsCurrentYear = action.payload?.totals;
    })
    .addCase(getDashboardUsers.fulfilled, (state, action) => {
      state.dashboardUsers = action.payload;
    })
    .addCase(getUnderbookingUsers.fulfilled, (state, action) => {
      state.dashboardUnderbookingUsers = action.payload;
    })
    .addCase(getOverbookingUsers.fulfilled, (state, action) => {
      state.dashboardOverbookingUsers = action.payload;
    })
    .addCase(getDashboardProjectFilters.fulfilled, (state, action) => {
      state.filtersDashboardProject = action.payload;
    })
    .addCase(getPlGoals.fulfilled, (state, action) => {
      state.plGoals = action.payload;
    })
    .addCase(getSALPlanning.fulfilled, (state, action) => {
      state.salPlanning = action.payload;
    })
    .addCase(getChiaviMisura.fulfilled, (state, action) => {
      state.chiaviMisura = action.payload;
    })
    .addCase(saveDashboardProjectFilters, (state, action) => {
      state.filtersDashboardProjectUsed = action.payload;
    })
    .addCase(saveDashboardPeopleFilters, (state, action) => {
      state.filtersDashboardPeopleUsed = action.payload;
    })
    .addCase(saveDashboardSalFilters, (state, action) => {
      state.filtersDashboardSalUsed = action.payload;
    })
    .addCase(saveDashboardStoricoFilters, (state, action) => {
      state.filtersDashboardStoricoUsed = action.payload;
    });
});
